import React from "react";
import { extractAnimatedHeightProps, filterObjectByExcludedKeys } from "./util";
import { AnimatedHeight } from "./animatedHeight";

export const withAnimatedHeight = (component) => {
  const render = (props) => {
    const animatedHeightProps = extractAnimatedHeightProps(props);
    const animatedHeightPropKeys = Object.keys(animatedHeightProps);

    // we want to get all of the props that are not used by AnimatedHeight
    // and pass them in as outerProps. This way they will be spread
    // onto the component we pass in, i.e. (AnimatedHeightCol = withAnimatedHeight(Col)) 
    // would result in something like <AnimatedHeightCol show={true} md={6}> 
    // which would render <Col md={6}> as the outer component
    const componentProps = filterObjectByExcludedKeys(props, animatedHeightPropKeys);
    return (
      <AnimatedHeight {...animatedHeightProps} outerProps={componentProps} element={component} />
    );
  };
  return render;
};